import types from '@/vuex/vinculos-documento/mutations-types'

const mutations = {
  [types.SET_LISTA_VINCULOS_DOCUMENTO]: (state, payload) => {
    state.listaVinculosDocumento = payload.listaVinculosDocumento
  },
  [types.SET_DOCUMENTO_AGREGADOR]: (state, payload) => {
    state.documentoAgregador = payload.documentoAgregador
  }
}
export default mutations
